/**
 * Sequencer domain types — shared between the frontend store, the API
 * routes, and the Zod validation layer so there's a single source of
 * truth for the Project → Bank → Pattern hierarchy.
 *
 * These types intentionally cover BOTH the new hierarchy (Project
 * containing banks of patterns) AND the leaf types a pattern needs
 * (steps, pads, MIDI definitions, etc.) because the API's Zod schemas
 * validate all the way down to the step cell.
 */
export const STEP_COUNTS = [16, 32, 64, 128];
// ── Pattern / Bank / Project hierarchy ────────────────────────────
/** Fixed 16 pads per bank; not user-configurable. */
export const PADS_PER_BANK = 16;
/**
 * Every project ships with these four banks (A/B/C/D), matching
 * classic groovebox convention. Bank labels are renameable; bank
 * ids are stable so cross-references (song entries, sync payloads)
 * don't drift.
 */
export const DEFAULT_BANK_IDS = ['A', 'B', 'C', 'D'];
export const MAX_BANKS_PER_PROJECT = DEFAULT_BANK_IDS.length;
/** Ticks per step. Matches the MPC / Renoise convention of 96
 *  ticks per quarter; with 16 steps = 4 beats, one step = 24
 *  ticks. Stored on the type module so the scheduler + piano
 *  roll + automation resolver all agree without a runtime
 *  import cycle. */
export const TICKS_PER_STEP = 24;
/** Reserved id for the always-present master bus. Pads with no
 *  explicit `padBus` entry route here; master's output feeds the
 *  global FX bank → OutputSink chain. */
export const MASTER_BUS_ID = 'master';
//# sourceMappingURL=sequencer.js.map